<div class="container">
  <div class="row">
    <div class="col-1"></div>
    <div class="col-10 folat-end">
      <button type="button" class="btn btn-primary" (click)="open(content)">Add New Item</button>
    </div>
    <div class="col-1"></div>
  </div>
  <br>
    <div class="row">
      <div class="col-1"></div>
      <div class="col-10 table-responsive text-center">
        <table class="table table-bordered">
          <thead>
            <tr class="header-color">
              <th>#</th>
              <th>Name</th>
              <th>Description</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Quantity Paid</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @if (list_length == 0) {
              <tr>
                <td colspan="7">No data found</td>
              </tr>
            }
            @for (item of items; track item; let i = $index) {
              <tr>
                <td>{{((filter_config.currentPage - 1) * filter_config.itemsPerPage) + (i+1)}}</td>
                <td>{{item?.name}}</td>
                <td>{{item?.description}}</td>
                <td>{{item?.quantity}}</td>
                <td>{{item?.price}}</td>
                <td>{{item?.paid_quantity}}</td>
                <td>
                  <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group"
                    style="direction:ltr">
                    <button [disabled]="!utility.isAdmin()" type="button" class="btn btn-danger"
                    (click)="onDelete(item.id)">Delete</button>
                    <button type="button" class="btn btn-secondary"
                    (click)="edit(content2, item)">Update</button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="col-1"></div>
    </div>
    <div class="row">
      <div class="col-1"></div>
      <div class="col-10">
        <mat-paginator #paginator showFirstLastButtons [length]="filter_config.totalItems"
          [pageSize]="filter_config.itemsPerPage" [pageSizeOptions]="filter_config.pageSizeOptions"
          (page)="pageChangeEvent($event)">
        </mat-paginator>
      </div>
      <div class="col-1"></div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Add New Item</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="name">Name</label>
        <input type="text" class="form-control" [(ngModel)]="item.name" id="name">
      </div>
      <div class="mb-3">
        <label for="description">Description</label>
        <input type="text" class="form-control" [(ngModel)]="item.description" id="description">
      </div>
      <div class="mb-3">
        <label for="price">Price</label>
        <input type="number" class="form-control" [(ngModel)]="item.price" id="price">
      </div>
      <div class="mb-3">
        <label for="quantity">Quantity</label>
        <input type="number" class="form-control" [(ngModel)]="item.quantity" id="quantity">
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnSubmit()">Add</button>
    </div>
  </ng-template>
  <ng-template #content2 let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Update Setting Item</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="name">Name</label>
        <input type="text" class="form-control" [(ngModel)]="new_item.name" id="name">
      </div>
      <div class="mb-3">
        <label for="description">Description</label>
        <input type="text" class="form-control" [(ngModel)]="new_item.description" id="description">
      </div>
      <div class="mb-3">
        <label for="price">Price</label>
        <input type="number" class="form-control" [(ngModel)]="new_item.price" id="price">
      </div>
      <div class="mb-3">
        <label for="quantity">Quantity</label>
        <input type="number" class="form-control" [(ngModel)]="new_item.quantity" id="quantity">
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnUpdate(update_key)">Update</button>
    </div>
  </ng-template>